import React, { useEffect, useState } from "react";
import "./DeleteModal.css";
import { Box } from "@mui/material";
import Title from "../title/Title";
import {
  DeleteButton,
  SecondaryButton,
} from "../buttonComponent/ButtonComponent";
import DeleteIcon from "./img/deleteIcon.svg";
import ModalCloseButton from "./ModalCloseButton";
import RetireIcon from "./img/retireIcon.svg";
import { formatTo12HourTime } from "../../config/utilities/fDate";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#FFFFFF",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  p: 0,
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
};

const DeleteModal = ({
  loading,
  isOpen,
  onClose,
  onDelete,
  itemName,
  module,
  stackLevel = 0,
}) => {
  if (!isOpen) return null;

  const [title, setTitle] = useState("");
  const [mainText, setMainText] = useState("");
  const [action, setAction] = useState("");

  useEffect(() => {
    if (module === "parent") {
      setTitle("Delete Parent Data");
      setMainText(itemName.familyId);
      setAction("remove");
    } else if (module === "admin") {
      setTitle("Delete Admin User");
      setMainText(`${itemName.firstName} ${itemName.lastName}`);
      setAction("remove");
    } else if (module === "notifications") {
      setTitle("Delete Notifications Campaign");
      setMainText(itemName.name);
      setAction("remove");
    } else if (module === "stops") {
      setTitle("Delete Stop");
      setMainText(itemName.name);
      setAction("remove");
    } else if (module === "trips") {
      setTitle("Delete Trips");
      setMainText(itemName.name);
      setAction("remove");
    } else if (module === "vehicles") {
      setTitle("Retire Vehicle");
      setMainText(itemName.vehicleNumber);
      setAction("retire");
    } else if (module === "drivers") {
      setTitle("Retire Driver");
      setMainText(itemName.name);
      setAction("retire");
    } else if (module === "scheduling") {
      setTitle("Delete Scheduled Trip");
      setMainText(`${itemName.tripDetails.tripName} at ${formatTo12HourTime(itemName.startTime)}`);
      setAction("remove");
    } else if (module === "serviceAnnouncement") {
      setTitle("Delete Service Announcement");
      setMainText(`${itemName.title}`)
      setAction("remove");
    } else if (module === "busPolicy") {
      setTitle("Delete Bus Policy");
      setMainText(`${itemName.title}`)
      setAction("remove");
    } else if (module === "generalPolicy") {
      setTitle("Delete General Policy");
      setMainText(`${itemName.title}`)
      setAction("remove");
    } else if (module === "institution") {
      setTitle("Delete Institution");
      setMainText(
        itemName?.institutionName || itemName?.institutionId || ""
      );
      setAction("remove");
    } else if (module === "deeplink") {
      setTitle("Delete Deeplink");
      setMainText(itemName?.label || "");
      setAction("remove");
    }
  }, [module, itemName]);

  return (
    <div
      className="modal-backdrop"
      style={{ zIndex: 999 + stackLevel }}
    >
      <Box sx={style}>
        <div>
          <div className="modal-header-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <img loading="lazy" src={action === "retire" ? RetireIcon : DeleteIcon} alt="invite-users-icon" />
              <ModalCloseButton onClick={onClose} />
            </div>
            <Title
              title={title}
              deleteSubtitle
              titleSize="1.125rem"
              subtitleSize="0.875rem"
              gap="0rem"
              lineHeight="1.75rem"
            >
              Are you sure you want to{" "}
              {action === "retire" ? "retire" : "remove"} {mainText}. This
              action cannot be undone.
            </Title>
          </div>
          <div className="button-container-delete">
            <SecondaryButton
              label="Cancel"
              width="170px"
              imageIcon={false}
              onClickFunction={onClose}
            />
            <DeleteButton
              loading={loading}
              label="Confirm"
              buttonWidth="170px"
              buttonHeight="2.75rem"
              disable={false}
              onClickFunction={() => onDelete(itemName)}
            />
          </div>
        </div>
      </Box>
    </div>
  );
};

export default DeleteModal;
